<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ack"></a></p>
<div class="fmhT sgc-1">
    ACKNOWLEDGMENTS
  </div>
<div class="fmtx1">
<b>T</b>HE <i>DRIFTLESS</i> STORY TOOK OVER TEN YEARS TO COMPLETE AND IT’S not like I wasn’t trying. One reason may be the characters who wanted to be written about. They were for the most part not the kind of characters who usually find their way into print—very private, never satisfied with their assigned roles, always wanting their voices to be more accurately rendered and their feelings better dramatized. Some were more comfortable with my wife, Edna, than with me, and for over a decade she tirelessly advocated on their behalf. Her assistance was instrumental throughout the entire process.
  </div>
<div class="fmtx">
    The work would never have been finished without the additional help of many generous people. The life and times of my friend Mike Cannell provided vital inspiration. Others helped with sage advice, editing, critical insights, living facts, and invaluable intuitions. These include: Mike Austin, Pam Austin, Steve Barza, Barry Clark, Jenny Clark, William Davis, Peter Egan, Jim Goodman, Francis Goodman, Rebecca Goodman, Darrel Hanold, Linda Kiemele, John Kinsman, Charlie Knower, Patti Knower, Lewis Koch, Jim Kolkmeier, Leslie Kolkmeier, Jerry McConoughey, Judy McConoughey, Kathleen Nett, Jim Noland, Bronwyn Schaefer Pope, Luther Rhodes, Stephen Rhodes, Paul Schaefer, Ed Schultz, Alexandra Stanton, Blaine Taylor, Judy Taylor, and Peter Whiteman. I’m grateful to my agent Lois Wallace, and I especially want to acknowledge Milkweed editor Ben Barnhart for his creative discernment and priceless suggestions on structure and tone. Thanks to all.
  </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// davi_9781571318008_oeb_ack_r1.vue?2ec5f63b